export default {
  form: {
    header: {
      label: 'Cabeçalho',
      placeholder: 'Cabeçalho',
    },
    qr_code_header: {
      label: 'Título da caixa',
      placeholder: 'Título da caixa',
    },
    qr_code_description: {
      label: 'Descrição da caixa',
      placeholder: 'Descrição da caixa',
    },
    tag_text: {
      label: 'Texto da etiqueta',
      placeholder: 'NOVO!',
    },
    footer: {
      label: 'Texto do rodapé',
      placeholder: 'Introduza o texto do rodapé',
    },
    url_type: {
      label: 'URL',
      placeholder: 'Selecionar URL',
    },
    url: {
      placeholder: 'www.example.com',
    },
    primary_color: {
      label: 'Cor primária',
    },
    background_color: {
      label: 'Cor de fundo',
    },
    logo: {
      label: 'Logótipo',
    },
  },
  toasts: {
    failed_to_load_data: 'Falha ao carregar o folheto',
  },
};
